import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["menu", "trigger"];

  connect() {
    this.toggleClass = this.data.get("class") || "hidden";
    this.activeClass = this.data.get("activeClass") || "header-item-active";
  }

  toggle() {
    this.menuTarget.classList.toggle(this.toggleClass);
    this._syncTriggerState();
  }

  hide(event) {
    if (
      this.element.contains(event.target) === false &&
      !this.menuTarget.classList.contains(this.toggleClass)
    ) {
      this.menuTarget.classList.add(this.toggleClass);
      this._syncTriggerState();
    }
  }

  _syncTriggerState() {
    if (!this.hasTriggerTarget) return;

    const isOpen = !this.menuTarget.classList.contains(this.toggleClass);
    this.triggerTarget.classList.toggle(this.activeClass, isOpen);
  }
}
